export const LESSON_VALIDATION_SOURCE = 'lesson_validation';
export const BANNER_VALIDATION_SOURCE = 'banner_validation';

export const ERROR_VALIDATION_FAILURE = 'LessonValidator.ValidationFailure';
export const ERROR_INVALID_LESSON     = 'LessonValidator.InvalidLesson';

export const CREATE_ENTITY       = 'entities/create';
export const ADD_LIST_ELEMENT    = 'entities/addListElement';
export const REMOVE_LIST_ELEMENT = 'entities/removeListElement';
export const SET_ATTRIBUTE       = 'entities/setAttribute';

export const KIND = '_kind';
